import { useSetupContext } from "@/modules/Backtest/hooks";
import React from "react";
import { Col, Form, Row } from "antd";
import BacktestOptions from "./BacktestOptions";
import BrokerOption from "./BrokerOptions";
import PeerOptions from "./PeerOptions";

export default () => {
  const { form } = useSetupContext();
  const options = [<BacktestOptions />, <BrokerOption />, <PeerOptions />];

  return (
    <Form form={form}>
      <Row gutter={[8, 8]}>
        {options.map((e, i) => (
          <Col span={24} key={i}>
            {e}
          </Col>
        ))}
      </Row>
    </Form>
  );
};
